import io from "socket.io-client";
import config from "../config/config";
import { isShareView } from "../share/shareView";


export let socket: any;
export let socketForConversionSetup: any;

export const socketConnection = () => {
  return socket;
};

export const connectSocketForAnalyticsView = (
  socketOptions: any,
  readyCb?: () => any
) => {
  // DEMO BUILD ONLY (REACT_APP_DEMO=1): no network socket; the demo's own traffic is delivered through a fake one (src/demo/). Removed from normal builds at build time.
  if (process.env.REACT_APP_DEMO === "1") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const demo = require("../demo/demoRuntime");
    socket = demo.demoSocket;
    if (readyCb) {
      readyCb();
    }
    demo.startDemoTraffic();
    demo.deliverSnapshot();

    return socket;
  }

  // A RECIPIENT'S VIEWER (a shared clip's page): no network socket either. Nothing is live in a clip; a socket-shaped object with no network lets the dashboard start as it always does.
  if (isShareView()) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    socket = require("../demo/fakeSocket").createFakeSocket();
    if (readyCb) {
      readyCb();
    }

    return socket;
  }

  // Reuse the existing socket ONLY if it's actually still connected - was
  // `if (socket)` alone, which reused a dead/disconnected socket object
  // forever once one existed (e.g. after disconnectSocket() failed to
  // clear this module-level variable - see its own comment below - or
  // after any other path left a stale reference lying around).
  //
  // Reported live 2026-08-08: a dashboard session left open overnight
  // logged the customer out (normal, expected). After logging back in,
  // a tracked site's socket had gone silently dead (a separate bug, in
  // the tracking script's own restoreConnection()) - but even after
  // fixing that and getting a real session to appear, the DASHBOARD
  // itself needed a second full page reload before real-time interaction
  // pulses started working. Root cause: this function was handing back
  // the same disconnected socket object every time, no matter how many
  // times it got called, because `if (socket)` doesn't ask whether that
  // socket is actually alive.
  if (socket && socket.connected) {
    if (readyCb) {
      readyCb();
    }
    return socket;
  }

  // @ts-ignore
  socket = io.connect(config.socketServerPath, socketOptions);
  socket.on("connect", () => {
    if (readyCb) {
      readyCb();
    }
  });
  socket.on("error", (error: any) => {
    console.log("error--socket", error);
  });
  return socket;
};

export const connectSocketForConversionSetup = (socketOptions: any) => {
  // Same fix as connectSocketForAnalyticsView above - was `if
  // (socketForConversionSetup)` alone.
  if (socketForConversionSetup && socketForConversionSetup.connected) {
    return socketForConversionSetup;
  }

  // @ts-ignore
  socketForConversionSetup = io.connect(
    config.socketServerPath,
    socketOptions
  );

  return socketForConversionSetup;
};

export const disconnectSocket = () => {
  // Clearing the module-level reference after disconnect() is the actual
  // fix, not just a tidy-up - without this, the next
  // connectSocketForAnalyticsView call saw a truthy `socket` (still
  // pointing at the now-dead object) and reused it forever instead of
  // ever reconnecting. socket.disconnect() alone only kills the
  // connection; it doesn't erase this module's own reference to it.
  if (socket) {
    socket.disconnect();
    socket = undefined;
  }
  if (socketForConversionSetup) {
    socketForConversionSetup.disconnect();
    socketForConversionSetup = undefined;
  }
};
export const disconnectSocketForConversionSetup = () => {
  if (socketForConversionSetup) {
    socketForConversionSetup.disconnect();
    socketForConversionSetup = undefined;
  }
};
